/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Auto_CtaInputs */

const en_mk_build_auto_cta = /** @type {(inputs: Mk_Build_Auto_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore automatic building`)
};

const id_mk_build_auto_cta = /** @type {(inputs: Mk_Build_Auto_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenali cara otomatis`)
};

/**
* | output |
* | --- |
* | "Explore automatic building" |
*
* @param {Mk_Build_Auto_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_auto_cta = /** @type {((inputs?: Mk_Build_Auto_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Auto_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_auto_cta(inputs)
	return en_mk_build_auto_cta(inputs)
});